/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { CellRange } from "./CellRange";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridSelectedCellRangesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedCellRangesCollection, _super);
    function GridSelectedCellRangesCollection() {
        return _super.call(this, CellRange.$, 0) || this;
    }
    Object.defineProperty(GridSelectedCellRangesCollection.prototype, "ae", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedCellRangesCollection.$t = markType(GridSelectedCellRangesCollection, 'GridSelectedCellRangesCollection', ObservableCollection$1.$.specialize(CellRange.$));
    return GridSelectedCellRangesCollection;
}(ObservableCollection$1));
export { GridSelectedCellRangesCollection };
//# sourceMappingURL=GridSelectedCellRangesCollection.js.map
